/**
 * mcycle homepage select list module
 * @Create jiangbao(jiangbao1123@gmail.com)
 * @CreateDate  2017/12/8
 */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import classNames from 'classname';
import Arrow from '../../../svgs/arrow';
// import extendSearch from '../../../utils/extendSearch';
// import { category } from '../../../reducers/home';

class SelectItem extends Component {
  constructor(props) {
    super(props);
    this.state = { showMore: false };
  }

  // click show more button
  onMoreClick = () => {
    this.setState({ showMore: !this.state.showMore });
  }

  render () {
    const { showMore } = this.state;
    const type = this.props.type;
    const { current, list } = this.props.data;
    // const search = this.props.location.search;
    const { brand, category } = this.props;
    const showMoreSetting = {
      text: showMore ? '收起' : '更多',
      class: showMore ? 'up-arrow' : ''
    }

    return (
      <div className="mcycle-select-item clearfix">
        <p className="mcycle-select-title">{ this.props.title }：</p>
          {/* brand || category list */}
          <ul className="mcycle-select-list">
            {
              list.map((item, index) => (
                <li key={ index } className={classNames({
                  'active': item.id === current,
                  'item-hide': index > 6 && !showMore
                })}>
                  <Link to={{ 
                      path: '/',
                      search: type === 'brand' ? `cid=${category.current}&bid=${item.id}` : `cid=${item.id}`,
                      state: type === 'brand' ? 
                      { cid: category.current, bid: item.id, brand: brand, isEffect: item.id !== current }
                      :{ cid: item.id, isEffect: item.id !== current } }
                    }>
                    { item.name }
                  </Link>
                </li>
              ))
            }
          </ul>

          {/* show more button */}
          <div className={ classNames("mcycle-select-more", showMoreSetting.class) } 
            onClick={ this.onMoreClick }
            style={ {display: list.length > 7 ? 'block' : 'none'} }>
            { showMoreSetting.text } <Arrow />
          </div>
      </div>
    )
  }
}

export default connect(
  state => ({
    brand: state.home.brand,
    category: state.home.category,
    location: state.router.location
  })
)(SelectItem)


// WEBPACK FOOTER //
// ./src/components/home/selectList/selectItem.js